import { gql } from '@apollo/client';

const schema = {
  delete: {
    name: "deletePaymentType",
    serviceName: "admin",
    query: gql`
      mutation deletePaymentType($ids: [String]!) {
        deletePaymentType(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
